<template>
  <div>
    <Form :model="basicModel" class="inputForm labelForm threeForm" ref="knowexForm" :rules="basicRules"> 
            <FormItem prop="cfdYears" class="item2 notopthreelabel" :label='$t("three_title1")'>
                <effect-select  v-model="basicModel.cfdYears" :options='howMuchYear' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="experienceYears" class="item2 notopthreelabel" :label='$t("three_title2")'>
                <effect-select  v-model="basicModel.experienceYears" :options='howMuchYear' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="futureYears" class="item2 notopthreelabel" :label='$t("three_title3")'>
                <effect-select  v-model="basicModel.futureYears" :options='howMuchYear' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <!-- <FormItem prop="commodityYears" class="item2 nothreelabel" :label='$t("three_title4")'>
                <effect-select  v-model="basicModel.commodityYears" :options='howMuchYear' :isLanguage='false' :isLabel="true" ></effect-select>
            </FormItem> -->
            <FormItem prop="averageTradeSize" class="item2 notopthreelabel" :label='$t("three_title5")'>
                <effect-select  v-model="basicModel.averageTradeSize" :options='averageTradeSize' :isLanguage='false' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="maximumLeverageAmount" class="item2 notopthreelabel" :label='$t("three_title6")'>
                <effect-select  v-model="basicModel.maximumLeverageAmount" :options='maxLeveragedAmount' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="whichLeverage" class="item2 notopthreelabel" :label='$t("three_title7")'>
                <effect-select  v-model="basicModel.whichLeverage" :options='tradingLeveraged' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="likelyToHappen" class="item2 notopthreelabel" :label='$t("three_title8")'>
                <effect-select  v-model="basicModel.likelyToHappen" :options='stopLoss' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="timesPersonallyTrade" class="item2 notopthreelabel" :label='$t("three_title9")'>
                <effect-select  v-model="basicModel.timesPersonallyTrade" :options='tradeTimes' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="affordTotalInconme" class="item2 notopthreelabel" :label='$t("three_title10")'>
                <effect-select  v-model="basicModel.affordTotalInconme" :options='totalIncome' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="productsExperience" class="item2 notopthreelabel" :label='$t("three_title11")'>
                <effect-select  v-model="basicModel.productsExperience" :options='productExperience' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="affordToLose" class="item2 notopthreelabel" :label='$t("three_title12")'>
                <effect-select  v-model="basicModel.affordToLose" :options='loseAffect' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="investmentObjective" class="item2 notopthreelabel" :label='$t("three_title13")'>
                <effect-select  v-model="basicModel.investmentObjective" :options='investStatement' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem class="itemBtns">
                <Button type="primary" class="formBtn"  @click="back">{{$t('back')}}</Button>
                <Button type="primary" class="formBtn"  @click="next">{{$t('next')}}</Button>
            </FormItem>
    </Form>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import EffectInput from '@/components/EffectInput.vue';
import EffectSelect from '@/components/EffectSelect.vue';
import Loading from '@/components/Loading.vue';



export default {
  name: 'Home',
  components: {
    EffectInput, 
    EffectSelect,
    Loading
  },
  data(){
    return{
        loading:false,
        basicModel:{
            optionsYears: "",
            experienceYears: "",
            futureYears: "",
            commodityYears: "",
            cfdYears: "",
            averageTradeSize: "",
            maximumLeverageAmount: "",
            whichLeverage: "",
            likelyToHappen: "",
            timesPersonallyTrade: "",
            affordTotalInconme: "",
            productsExperience: "",
            affordToLose: "",
            investmentObjective: ""
        },
        basicRules: {
            optionsYears: [
                { required: true, message:this.$t('fieldError') , trigger: 'change' },
            ],
            experienceYears: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            futureYears: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            commodityYears: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            cfdYears: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            averageTradeSize: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            maximumLeverageAmount: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            whichLeverage: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            likelyToHappen: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            timesPersonallyTrade: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            affordTotalInconme: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            productsExperience: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            affordToLose: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            investmentObjective: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
        },
        howMuchYear:[
            {
                value:'1',
                label:'three_year1'
            },
            {
                value:'2',
                label:'three_year2'
            },
            {
                value:'3',
                label:'three_year3'
            },
            {
                value:'4',
                label:'three_year4'
            }
            ,
            {
                value:'5',
                label:'three_year5'
            }
        ],
        //What has been your average trade size in Forex, CFDS, Futures and commodities Lots?
        averageTradeSize:[
            {
                value:'1',
                label:'three_neverTrade'
            },
            {
                value:'2',
                label:'three_trade1'
            },
            {
                value:'3',
                label:'three_trade2'
            },
            {
                value:'4',
                label:'three_trade3'
            },
            {
                value:'5',
                label:'three_trade4'
            }
        ],
        //When you make a deposit of $5,000 and the instrument leverage is 1:30, what is the maximum leveraged amount you can trade with?
        maxLeveragedAmount:[
            {
                value:'1',
                label:'$5,000'
            },
            {
                value:'2',
                label:'$15,000'
            },
            {
                value:'3',
                label:'$150,000'
            },
            {
                value:'4',
                label:'$300,000'
            }
        ],
        //The market moves by 2%. Trading with what leverage woud lead to the largest potential profit or loss?
        tradingLeveraged:[
            {
                value:'1',
                label:'1:2'
            },
            {
                value:'2',
                label:'1:10'
            },
            {
                value:'3',
                label:'1:20'
            },
            {
                value:'4',
                label:'1:30'
            }
        ],
        //When you place a Stop-Loss order,what is more likely to happen?
        stopLoss:[
            {
                value:'1',
                label:'three_stopLoss1'
            },
            {
                value:'2',
                label:'three_stopLoss2'
            }
        ],
        //How many times have you personally traded on average per quarter in forex,CFDs or other similar
        tradeTimes:[
            {
                value:'1',
                label:'three_tradeTimes'
            },
            {
                value:'2',
                label:'1 - 20'
            },
            {
                value:'3',
                label:'21 - 40'
            },
            {
                value:'4',
                label:'40 +'
            }
        ],
        //Approximately what proportion of you total income you can afford to invest with EC Markets?
        totalIncome:[
            {
                value:'1',
                label:'three_totalIncome'
            },
            {
                value:'2',
                label:'6–15%'
            },
            {
                value:'3',
                label:'16–25%'
            },
            {
                value:'4',
                label:'over 25%'
            }
        ],
        //Do you have any experience or qualifications relevant to the understanding of youu products?
        productExperience:[
            {
                value:'1',
                label:'three_experience1'
            },
            {
                value:'2',
                label:'three_experience2'
            },
            {
                value:'3',
                label:'three_experience3'
            },
            {
                value:'4',
                label:'three_experience4'
            }
        ],
        //Assuming your invested capital with EC Markets is an amount you can afford to lose without affecting your capability to meet your financial obiligations. How will you feel/react in case you lose that amount as a result of trading CFDs?
        loseAffect:[
            {
                value:'1',
                label:'three_loseAffect1'
            },
            {
                value:'2',
                label:'three_loseAffect2'
            },
            {
                value:'3',
                label:'three_loseAffect3'
            },
            {
                value:'4',
                label:'three_loseAffect4'
            }
        ],
        //Which of the following statements best describes you objective for the assets you are investing?
        investStatement:[
            {
                value:'1',
                label:'three_statement1'
            },
            {
                value:'2',
                label:'three_statement2'
            },
            {
                value:'3',
                label:'three_statement3'
            },
            {
                value:'4',
                label:'three_statement4'
            }
        ],
        countryList:[],
        phoneList:[]
    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
        this.getData()
        // console.log(this.userInfo)
    },
    methods:{
        getData(){
            this.$axios.get('/api/UserQuestion/KonwledgeExperience')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    this.basicModel = Object.assign(this.basicModel,res.data.obj)
                    this.$refs.knowexForm.fields.forEach((v,j) => {
                        // console.log(v,j)
                        v.validateDisabled = true
                        v.validateMessage = ''
                        v.validateState = ''
                    })
                    // console.log(this.basicModel)
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => this.$Message.error(err.data.msg))
        },
        next(){
            this.$refs.knowexForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$axios.post('/api/UserQuestion/KonwledgeExperience', this.basicModel)
                    .then(async (res) => {
                        // console.log(res)
                        if(res.data.status == 1){
                            this.$Message.success(this.$t('saveSucccess'))
                            this.$emit('saveSteps',3)
                            this.$emit('changeSteps',3)
                            
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)
                } else {
                    // this.$Message.error('Fail!');
                }
            })
        },
        back(){
            this.$emit('changeSteps',1)
        }
    }
}
</script>
<style lang="less">
.verify{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    .content_wrapper{
        background-color: #f9fafb;
        border: 1px solid #f0f0f0;
        padding-top: 100px;
        .activate-process{
            position: relative;
            width: 60%;
            height: 3px;
            margin: 0px auto 110px;
            text-align: center;
            background-color: #e5e5e5;
            .process-item{
                position: absolute;
                top: -18px;
                left: 0px;
                transform: translateX(-50%);
                color: #332c2b;
                white-space: nowrap;
                span{
                    display: inline-block;
                    width: 34px;
                    height: 34px;
                    margin-bottom: 22px;
                    line-height: 34px;
                    color: #332c2b;
                    font-size: 14px;
                    background-color: #f5f5f5;
                    border: 1px solid #e5e5e5;
                    border-radius: 50%;
                    font-family: 'Montserrat-Regular';
                    cursor: pointer;
                }
                b{
                    font-weight: normal;
                }
            }
            .left25{
                left: 25%;
            }
            .left50{
                left: 50%;
            }
            .left75{
                left: 75%;
            }
            .left100{
                left: 100%;
            }
            .active,
            .complete,
            .finished{
                top: -24px;
                span{
                    width: 48px;
                    height: 48px;
                    margin-bottom: 14px;
                    font-size: 18px;
                    line-height: 48px;
                    background-color: #e32b3a;
                    border-color: #e32b3a;
                    color: #fff;
                    
                }
            }
            .active::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 50%;
                width: 72px;
                height: 3px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            .finished::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 70%;
                width: 160px;
                height: 4px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            
        }
    }
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
    .ivu-form-item{
        width: 48%;
    }
    
    .inputForm{
        h3{
            display: block;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
            padding-left: 20px;
            font-size: 18px;
            color: #332c2b;
            font-weight: normal;
        }
        h3::before{
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            width: 8px;
            height: 8px;
            background-color: #e32b3a;
            border-radius: 4px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
        }
        .item4{
            width: 24%;
        }
        .item2{
            width: 49%;
        }
        .itemtop{
            margin-top: 40%;
        }
    }
    .threeForm{
        justify-content: space-between!important;
    }
}
</style>
